<div class="component-body">

    <div class="container">
      <br>
      <br>
      <br>
      <br>
      <br>

      <div *ngIf="!hideterms">
        <div class="row">


          <div class="col-lg-12 col-sm-12 col-md-12">
            <div style="text-align: center">
              <h1>
                <label style="color:#005b9d"> {{'terms.TranslationSection.text1' | translate}}</label>
              </h1>
            </div>

              <div class="row">

           
              

                <div class="col-lg-12 col-md-12 col-sm-12">

                  <form [formGroup]="signupForm" (ngSubmit)="signup(signupForm)">
                    <h3>{{'terms.TranslationSection.text2' | translate}}</h3>

                   
                    <div style="overflow-y: scroll; overflow-x: hidden; height:300px; ">

                      <div class="row">

                      <div class="col-lg-12 col-md-12 col-sm-12">

                     
                        <p style="text-align: left;">{{'terms.TranslationSection.text3' | translate}} <br><br>{{'terms.TranslationSection.text4' | translate}}</p>
                              
                      
                      </div>
                      </div>


                      <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">

                      <p style="text-align: left;">{{'terms.TranslationSection.text5' | translate}}</p>
  
                      
                    </div>
                  </div>
                    



                
                    </div>
                    
                    
                    <div class="row" style="height: 20px;">
                    </div>

                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6">  
                    
                        <button matStepperPrevious type="button" style="background-color:#005b9d; color:white; " class="btn btn-md">{{'terms.TranslationSection.text6' | translate}}</button>&nbsp;

                        <button type="submit" style="background-color:#028d02; color:white;" class="btn btn-md">{{'terms.TranslationSection.text7' | translate}}</button>

                      </div>
                     
                    </div>


                    

                    
                    <div class="row">
                      <div class="col-lg-12 col-sm-12 col-md-12" style="text-align: center;">  
                    
                      <div id="loadimage">
                        <img *ngIf="loading" style="width:40px; height:40px;"
                          src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      </div>
                    </div>
                    </div>
                  </form>
                </div>
              </div>
           



          </div>
        </div>
      </div>



      <div *ngIf="!hidethankyou">

        <div class="row">


          <div class="col-lg-8 col-sm-8 col-md-8 mx-auto">


            <div class="card-group">
              <div class="card p-4">


                <div class="card-body">

                  <div style="text-align: center">
                    <h1>
                      <font color="#005b9d">{{'terms.TranslationSection.text8' | translate}}</font>
                    </h1>
                  </div>

                  <p>
                    {{'terms.TranslationSection.text9' | translate}} <a href="{{enrollURL}}/#/login">{{'terms.TranslationSection.text10' | translate}}</a>
                  </p>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>




    </div>

</div>
